export default __webpack_public_path__ + "static/media/Canadore College.jpg.a49e4c06.png";